import { installRandomUUID } from './lib/polyfills/random-uuid';

// Run synchronously before hydration, including third-party presence hooks.
installRandomUUID(globalThis.crypto);
